import { render, staticRenderFns } from "./PriceListsTable.vue?vue&type=template&id=55f52a3a&scoped=true&"
import script from "./PriceListsTable.vue?vue&type=script&lang=js&"
export * from "./PriceListsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f52a3a",
  null
  
)

export default component.exports